import { makeStyles } from '@material-ui/styles';
import { isEmpty } from 'lodash';

let theme = {
    light: '#ffffff',
    primary: '#1f282e',
    secondary: '#4f3486',
    success: '#93D50A',
    error: '#7f3586',
    danger: '#7f3586',
    info: '#54a684',
    warning: '#cb7537',
    dark: '#282F37',
    coolGrey: '#878c91',
    coldGrey: '#dde1eb',
};

if (!isEmpty(localStorage.theme)) {
    theme = { ...theme, ...JSON.parse(localStorage.theme) };
}

export const colorSet = theme;

export const typography = {
    typography: {
        fontFamily: [
            'proxima-nova',
            'itc-avant-garde-gothic-pro',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        overrides: {
            MuiCssBaseline: {
                '@global': {
                    '@font-face': ['proxima-nova'],
                },
            },
        },
        fontSize: 12,
        h1: {
            fontWeight: 500,
            fontSize: '2.125rem',
            lineHeight: 1.4,
        },
        h2: {
            fontWeight: 500,
            fontSize: '1.75rem',
            lineHeight: 1.4,
        },
        h3: {
            fontWeight: 500,
            fontSize: '1.5rem',
            lineHeight: 1.4,
        },
        h4: {
            fontWeight: 500,
            fontSize: '1.25rem',
            lineHeight: 1.4,
        },
        h5: {
            fontWeight: 500,
            fontSize: '1rem',
            lineHeight: 1.4,
        },
        h6: {
            fontWeight: 600,
            fontSize: '1rem',
            lineHeight: 1.4,
            color: '#99a5bd',
        },
    },
};

export const palette = {
    type: 'light',
    primary: { main: theme.primary },
    secondary: { main: theme.secondary },
    success: { main: theme.success },
    error: { main: theme.danger },
    info: { main: theme.info },
    warning: { main: theme.warning },
    light: { main: theme.light },
    dark: { main: theme.dark },
};

export const Theme = () => ({
    //BASE COLOR
    colorSuccess: { color: theme.success },
    colorInfo: { color: theme.info },
    colorDanger: { color: theme.danger },
    colorWarning: { color: theme.warning },
    colorPrimary: { color: theme.primary },
    colorSecondary: { color: theme.secondary },
    colorWhite: { color: `${theme.light} !important` },

    //BUTTONS BACKGROUND
    backgroundSuccess: { backgroundColor: `${theme.success} !important` },
    backgroundInfo: { backgroundColor: `${theme.info} !important` },
    backgroundDanger: { backgroundColor: `${theme.danger} !important` },
    backgroundWarning: { backgroundColor: `${theme.warning} !important` },
    backgroundPrimary: { backgroundColor: `${theme.primary} !important` },
    backgroundSecondary: { backgroundColor: `${theme.secondary} !important` },
    backgroundDark: { backgroundColor: `${theme.dark} !important` },
    backgroundLight: { backgroundColor: `${theme.light} !important` },

    borderSuccess: { borderColor: `${theme.success} !important` },
    borderInfo: { borderColor: `${theme.info} !important` },
    borderDanger: { borderColor: `${theme.danger} !important` },
    borderWarning: { borderColor: `${theme.warning} !important` },
    borderPrimary: { borderColor: `${theme.primary} !important` },
    borderSecondary: { borderColor: `${theme.secondary} !important` },
    borderDark: { borderColor: `${theme.dark} !important` },
    borderNormal: {
        borderSize: '3px',
        borderStyle: 'solid',
    },
    borderBold: {
        borderSize: '6px',
        borderStyle: 'solid',
    },
    borderRounded: {
        borderRadius: '16px',
    },

    //BUTTONS BACKGROUND
    buttonSuccess: {
        border: '2px solid white !important',
        backgroundColor: `${theme.success} !important`,
        borderRadius: '12px !important',
        color: 'white !important',
        fontWeight: 'bold',
        fontSize: '0.833rem',
        boxShadow: '2px 2px rgba(0,0,0,0.15)',
        padding: '0.3em 2em',
        '&:hover': {
            borderColor: `${theme.success} !important`,
            color: `${theme.success} !important`,
            backgroundColor: 'white !important',
        },
    },
    buttonInfo: {
        border: '2px solid white !important',
        backgroundColor: `${theme.info} !important`,
        borderRadius: '12px !important',
        color: 'white !important',
        fontWeight: 'bold',
        fontSize: '0.833rem',
        boxShadow: '2px 2px rgba(0,0,0,0.15)',
        padding: '0.3em 2em',
        '&:hover': {
            borderColor: `${theme.info} !important`,
            color: `${theme.info} !important`,
            backgroundColor: 'white !important',
        },
    },
    buttonDanger: {
        border: '2px solid white !important',
        backgroundColor: `${theme.danger} !important`,
        borderRadius: '12px !important',
        color: 'white !important',
        fontWeight: 'bold',
        fontSize: '0.833rem',
        boxShadow: '2px 2px rgba(0,0,0,0.15)',
        padding: '0.3em 2em',
        '&:hover': {
            borderColor: `${theme.danger} !important`,
            color: `${theme.danger} !important`,
            backgroundColor: 'white !important',
        },
    },
    buttonWarning: {
        border: '2px solid white !important',
        backgroundColor: `${theme.warning} !important`,
        borderRadius: '12px !important',
        color: 'white !important',
        fontWeight: 'bold',
        fontSize: '0.833rem',
        boxShadow: '2px 2px rgba(0,0,0,0.15)',
        padding: '0.3em 2em',
        '&:hover': {
            borderColor: `${theme.warning} !important`,
            color: `${theme.warning} !important`,
            backgroundColor: 'white !important',
        },
    },
    buttonSecondary: {
        border: '2px solid white !important',
        backgroundColor: `${theme.secondary} !important`,
        borderRadius: '12px !important',
        color: 'white !important',
        fontWeight: 'bold',
        fontSize: '0.833rem',
        boxShadow: '2px 2px rgba(0,0,0,0.15)',
        padding: '0.3em 2em',
        '&:hover': {
            borderColor: `${theme.secondary} !important`,
            color: `${theme.secondary} !important`,
            backgroundColor: 'white !important',
        },
    },
    buttonPrimary: {
        border: '2px solid white !important',
        backgroundColor: `${theme.primary} !important`,
        borderRadius: '12px !important',
        color: 'white !important',
        fontWeight: 'bold',
        fontSize: '0.833rem',
        boxShadow: '2px 2px rgba(0,0,0,0.15)',
        padding: '0.3em 2em',
        '&:hover': {
            borderColor: `${theme.primary} !important`,
            color: `${theme.primary} !important`,
            backgroundColor: 'white !important',
        },
    },
    whiteButton: {},

    //BUTTONS BACKGROUND
    badgeSuccess: { borderColor: theme.success, color: theme.success },
    badgeInfo: { borderColor: theme.info, color: theme.info },
    badgeDanger: { borderColor: theme.danger, color: theme.danger },
    badgeWarning: { borderColor: theme.warning, color: theme.warning },
    badgePrimary: { borderColor: theme.primary, color: theme.primary },
    badgeSecondary: { borderColor: theme.primary, color: theme.primary },

    //ALERTS
    alertInfo: { borderColor: theme.info },
    alertSuccess: { borderColor: theme.success },
    alertPrimary: { borderColor: theme.primary },
    alertSecondary: { borderColor: theme.secondary },
    alertWarning: { borderColor: theme.warning },
    alertDanger: { borderColor: theme.danger },

    alertIconInfo: { backgroundColor: theme.info },
    alertIconSuccess: { backgroundColor: theme.success },
    alertIconPrimary: { backgroundColor: theme.primary },
    alertIconSecondary: { backgroundColor: theme.secondary },
    alertIconWarning: { backgroundColor: theme.warning },
    alertIconDanger: { backgroundColor: theme.danger },

    isActive: {
        color: `${theme.primary} !important`,
        fontWeight: 'bold',
    },

    ///CARDS
    authCard: {
        minWidth: 280,
        maxWidth: 450,
        padding: 20,
        textAlign: 'center',
    },

    paymentForm: {
        padding: '2em 1em',
        margin: '1em 0',
        border: '2px solid lightgray',
        borderRadius: '28px',
        background: '#7b3984',
    },

    cardErrors: {
        color: 'red',
        fontWeight: 'bold',
        marginBottom: '1em',
    },

    cardSizeOverride: { width: '60%' },

    subscriptionPaper: {
        padding: '5px 30px',
        backgroundColor: '#93d50a',
        color: '#1e282f',
        borderRadius: '28px',
        margin: '10px',
        textAlign: 'center',
        textTransform: 'uppercase',
        fontWeight: 'bold',
    },

    fullWidth: {
        textAlign: 'center',
        flexGrow: 1,
    },

    subscriptionCardFree: {
        backgroundColor: '#dbe2eb',
    },

    subscriptionCardNonFree: {
        backgroundColor: '#7b3984',
        color: 'white',
        Divider: {
            borderColor: 'white',
        },
    },

    cardTitle: {
        textAlign: 'left',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        color: 'inherit',
        marginBottom: '1rem',
    },

    cardDescription: {
        margin: '1em 0',
        textAlign: 'left',
    },

    cardPrice: {
        fontWeight: 'bold',
        textAlign: 'left',
        textTransform: 'uppercase',
        fontSize: '1.25em',
        marginBottom: '1em',
    },

    iconButton: {
        // border: '2px solid #7b3984',
        minWidth: 12,
        backgroundColor: 'white',
        borderRadius: '50%',
        color: theme.primary,
        boxShadow: '2px 2px rgba(0,0,0,0.15)',
        '&:hover': {
            color: 'white',
            backgroundColor: theme.primary,
        },
    },

    cardContent: { paddingTop: '10px !important' },
    weight600: { fontWeight: 600 },
    highlight: {
        '&:hover': {
            borderRadius: 16,
            color: '#9bbd41 !important',
            fontWeight: 600,
            // backgroundColor: 'white',
        },
    },

    avatar: {
        small: {
            width: 24,
            height: 24,
        },
        large: {
            width: 64,
            height: 64,
        },
        xLarge: {
            width: 128,
            height: 128,
        },
    },

    dataTable: {
        text: {
            primary: theme.light,
            secondary: theme.secondary,
        },
        background: {
            default: theme.dark,
        },
        context: {
            background: '#cb4b16',
            text: '#FFFFFF',
        },
        divider: {
            default: theme.primary,
        },
        button: {
            default: theme.light,
            focus: theme.secondary,
            hover: theme.secondary,
            disabled: theme.coolGrey,
        },
        sortFocus: {
            default: 'rgba(0, 0, 0, .54)',
        },
        selected: {
            default: '#e3f2fd',
            text: theme.coldGrey,
        },
        highlightOnHover: {
            default: '#EEEEEE',
            text: theme.success,
        },
        striped: {
            default: '#FAFAFA',
            text: theme.coldGrey,
        },
        action: {
            button: theme.light,
            hover: theme.success,
            disabled: theme.coolGrey,
        },
    },

    ////NAVBAR
    topBar: {
        marginTop: 10,
        marginLeft: 10,
        marginRight: 10,
        padding: 10,
        minWidth: 'calc(100% - 20px)',

        // marginLeft: 10,
        // marginRight: 10,
        // padding: ,
        height: 250,
        borderRadius: '10px !important',
        // minWidth: '98.5% !important',
        // maxWidth: '98.5% !important',
    },
});

export const defaultStyles = makeStyles(Theme());
